import dayjs from 'dayjs';
import moment from 'jalali-moment';

export function displayToCanonicalIso(displayDay, isJalali, role = 'start') {
  if (!displayDay) return null;

  let d;
  if (moment.isMoment(displayDay)) {
    d = dayjs(displayDay.toISOString());
  } else if (displayDay && displayDay.toISOString) {
    try {
      d = dayjs(displayDay.toISOString());
    } catch {
      d = dayjs(displayDay);
    }
  } else {
    d = dayjs(displayDay);
  }

  if (!d || !d.isValid()) return null;

  if (!isJalali) {
    return role === 'start'
      ? d.startOf('day').toISOString()
      : d.endOf('day').toISOString();
  }

  const canonical = d;
  return role === 'start'
    ? canonical.startOf('day').toISOString()
    : canonical.endOf('day').toISOString();
}
